export const queryKeys = {
  articles: ["articles"],
  article: (id: number) => ["article", id],
  articleSlug: (slug: string) => ["article-slug", slug],

  categories: ["categories"],
  etiquettes: ["etiquettes"],

  rubriques: ["rubriques"],
  pays: ["pays"],
  parametres: ["parametres"],
  typesArticle: ["types-articles"],

  analyticsResume: ["analytics-resume"],
  articleStats: (articleId: number) => ["article-stats", articleId],

  utilisateurs: ["utilisateurs"],
  invitations: ["invitations"],

  commentaires: (articleId: number) => ["commentaires", articleId],
  likes: (articleId: number) => ["likes", articleId],

  verifications: ["verifications"],
  verification: (id: number) => ["verification", id],
  verificationSlug: (slug: string) => ["verification-slug", slug],

  traductionArticle: (articleId: number) => ["traductions-article", articleId],
  traductionVerification: (verificationId: number) => [
    "traductions-verification",
    verificationId,
  ],

  me: ["me"],
};